import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Loading } from '../ui';

// Lazy imports
const GeneralPage = lazy(
  () => import('../dashboard/general/pages/GeneralPage')
);
const PermissionPage = lazy(
  () => import('../dashboard/userConfig/pages/permissions/PermissionPage')
);
const InformationPage = lazy(
  () => import('../dashboard/userConfig/pages/information/InformationPage')
);
const CredentialsPage = lazy(
  () => import('../dashboard/userConfig/pages/credentials/CredentialsPage')
);
const SecurityPage = lazy(
  () => import('../dashboard/userConfig/pages/security/SecurityPage')
);
const CurrentPasswrodPage = lazy(
  () =>
    import('../dashboard/userConfig/pages/current-password/CurrentPasswrodPage')
);
const NewPasswordPage = lazy(
  () => import('../dashboard/userConfig/pages/new-password/NewPasswordPage')
);
const AccountPage = lazy(
  () => import('../dashboard/account/pages/AccountPage')
);
const AccountDetailPage = lazy(
  () => import('../dashboard/account/pages/AccountDetailPage')
);
const BankPage = lazy(() => import('../dashboard/bank/pages/BankPage'));
const BankDetailPage = lazy(
  () => import('../dashboard/bank/pages/BankDetailPage')
);
const PredictionPage = lazy(
  () => import('../dashboard/prediction/pages/PredictionPage')
);
const MovementPage = lazy(
  () => import('../dashboard/movement/pages/MovementPage')
);
const IncomePage = lazy(() => import('../dashboard/movement/pages/IncomePage'));
const ExpensePage = lazy(
  () => import('../dashboard/movement/pages/ExpensePage')
);
const MovementDetailPage = lazy(
  () => import('../dashboard/movement/pages/MovementDetailPage')
);
const ChatIaPage = lazy(() => import('../common/pages/chat/ChatIaPage'));

const DashboardRoutes = () => {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route index element={<GeneralPage />} />
        <Route path="general" element={<GeneralPage />} />
        <Route path="user-config" element={<PermissionPage />} />
        <Route path="user/information" element={<InformationPage />} />
        <Route path="user/credentials" element={<CredentialsPage />} />
        <Route path="user/security" element={<SecurityPage />} />
        <Route path="user/current-password" element={<CurrentPasswrodPage />} />
        <Route path="user/new-password" element={<NewPasswordPage />} />
        <Route path="account" element={<AccountPage />} />
        <Route path="account/:accountId" element={<AccountDetailPage />} />
        <Route path="bank" element={<BankPage />} />
        <Route path="bank/:bankId" element={<BankDetailPage />} />
        <Route path="prediction" element={<PredictionPage />} />
        <Route path="transactions" element={<MovementPage />} />
        <Route path="transaction/income" element={<IncomePage />} />
        <Route path="transaction/expense" element={<ExpensePage />} />
        <Route path="transaction/:id" element={<MovementDetailPage />} />
        <Route path="chat-ai" element={<ChatIaPage />} />
        <Route path="/" element={<Navigate to="/dashboard/general" />} />
      </Routes>
    </Suspense>
  );
};

export default DashboardRoutes;
